import React from 'react';
import { inject, observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import useWebChat from './useWebChat';
import ChatLauncher from './ChatLauncher';
import ChatPanel from './ChatPanel';

// 실시간문의 위젯 — App 에 한 번 올린다. 런처(오른쪽 아래) + 패널(홈/문의). 접수 화면의 고정 운임 바(데스크톱 120 · 모바일 100) 위로 올린다.
// 관리자 페이지에서는 숨긴다
const SERVICE_PATHS = ['/quickservice', '/cargoservice', '/moveservice'];
const HIDDEN_PREFIX = ['/admin', '/t/'];   // 관리자·고객 배송조회 페이지에는 띄우지 않는다
const BAR = { desktop: 120, mobile: 100 };
const GAP = { desktop: 24, mobile: 16 };

function ChatWidget({ loginStore }) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const { pathname } = useLocation();
  const { userInfo } = loginStore;
  const member = Boolean(userInfo && userInfo.userKey);
  const chat = useWebChat({ authKey: member ? userInfo.userKey : '', member });

  if (HIDDEN_PREFIX.some((p) => pathname.startsWith(p))) return null;

  const onService = SERVICE_PATHS.includes(pathname);
  const gap = mobile ? GAP.mobile : GAP.desktop;
  const bottom = gap + (onService ? (mobile ? BAR.mobile : BAR.desktop) : 0);

  return (
    <React.Fragment>
      {chat.open && <ChatPanel full={mobile} bottom={bottom + 76} chat={chat} onClose={chat.closePanel} />}
      {!(chat.open && mobile) && (
        <ChatLauncher
          open={chat.open}
          unread={chat.unread}
          toast={chat.toast}
          compact={mobile}
          bottom={bottom}
          onClick={chat.togglePanel}
          onToastClick={chat.openUnread}
        />
      )}
    </React.Fragment>
  );
}

export default inject('loginStore')(observer(ChatWidget));
